var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-show',{attrs:{"open":_vm.open,"title":_vm.title},on:{"close":function($event){return _vm.$emit('close')}}},[_c('cash-register-show-data',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }